// Lightweight parallax: translateY background images based on scroll position.
// Uses rAF throttling and IntersectionObserver to skip offscreen elements.

export function initParallax() {
  const containers = Array.from(document.querySelectorAll('[data-parallax]'));
  if (!containers.length) return;

  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const visible = new Set();
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      }
    },
    { rootMargin: '200px 0px' },
  );
  containers.forEach((el) => io.observe(el));

  let ticking = false;
  const speed = 0.12;

  const update = () => {
    ticking = false;
    for (const container of visible) {
      const bg = container.querySelector('.parallax__bg');
      if (!bg) continue;
      const rect = container.getBoundingClientRect();
      const containerCenter = rect.top + rect.height / 2;
      const viewportCenter = window.innerHeight / 2;
      const offset = (containerCenter - viewportCenter) * speed;
      bg.style.transform = `translate3d(0, ${-offset}px, 0)`;
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
}
